
import { defineComponent, ref, computed } from '@vue/composition-api';
import Section from '~/components/v5/Section.vue';
import SectionHeader from '~/components/v5/SectionHeader.vue';
import ArticleCard from '~/components/v5/ArticleCard.vue';
import FCSwiper from '~/components/FCSwiper.vue';

interface Article {
  id: string;
  title: string;
  source: string;
  imageUrl?: string;
  link: string;
  date?: string;
  featured?: boolean;
}

export default defineComponent({
  name: 'InTheNewsSection',
  components: {
    Section,
    SectionHeader,
    ArticleCard,
    FCSwiper,
  },
  setup() {
    const articles = ref<Article[]>([
      {
        id: '1',
        title: 'Athletech: Mike Tyson-Backed FightCamp launches kick tracking tech',
        source: 'Athletech',
        imageUrl: 'https://a.storyblok.com/f/152150/2116x1406/b045181008/tommy-interview.png',
        link: 'https://athletechnews.com/mike-tyson-backed-fightcamp-launches-kick-tracking-tech/',
        featured: true,
      },
      {
        id: '2',
        title: 'FightCamp punches its way to a $90m Round',
        source: 'Tech Crunch',
        link: 'https://techcrunch.com/2021/06/30/fightcamp-punches-its-way-to-a-90m-round/',
      },
      {
        id: '3',
        title: 'How FightCamp Is Teaching The World To Box',
        source: 'Forbes',
        link: 'https://www.forbes.com/sites/daveknox/2021/11/03/how-fightcamp-is-teaching-the-world-to-box/',
      },
      {
        id: '4',
        title: 'Jess Evans is showing others how to create their own \'Cinderella Man\' story',
        source: 'Muscle & Fitness',
        link: 'https://www.muscleandfitness.com/muscle-fitness-hers/hers-athletes-celebrities/jess-evans-is-showing-others-how-to-create-their-own-cinderella-man-story/',
      },
    ]);

    const featuredArticles = computed(() => articles.value.filter((a) => a.featured));
    const regularArticles = computed(() => articles.value.filter((a) => !a.featured));

    return {
      articles,
      featuredArticles,
      regularArticles,
    };
  },
});
